import { Route } from '@angular/router';

export const singlesTrainingStatisticsRoutes: Route[] = [
    {
        path: 'singles-training/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/singles-training-statistics-details/singles-training-statistics-details.component').then(
                (c) => c.SinglesTrainingStatisticsDetailsComponent
            ),
    },
    {
        path: 'singles-training/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/singles-training-statistics-games/singles-training-statistics-games.component').then(
                (c) => c.SinglesTrainingStatisticsGamesComponent
            ),
    },
    {
        path: 'singles-training/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/singles-training-statistics-games-details/singles-training-statistics-games-details.component'
            ).then((c) => c.SinglesTrainingStatisticsGamesDetailsComponent),
    },
];
